import React, { useEffect } from 'react';

import { useSiteConfig } from 'hooks/useSiteConfig';
import { Variant } from '__generated__/graphql';

//Partial definition of the MyCustomizer response
export interface MyCustomizerResponseData {
  productionData: { key: string; value: string }[];
  id: string;
  productId: string;
  productName: string;
  designImage: {
    url: string;
    id: string;
    filename: string;
    date: string;
    size: number;
  };
  createdAt: string;
  updatedAt: string;
  designId: number;
  price: number;
  [key: string]: any; // anything else? there's a LOT of data
}

interface MyCustomizerProps {
  variation: Variant;
  onProductCustomized(details: Partial<MyCustomizerResponseData>): void;
}

export const MyCustomizer = ({
  variation,
  onProductCustomized,
}: MyCustomizerProps) => {
  const { env } = useSiteConfig();
  const MC_BASEURL = env.myCustomizerDomain;
  const MC_SHOPID = env.myCustomizerShopId;
  const id = variation.myCustomizer?.iframeID || 'myCustomizer';
  const startPoint = variation.myCustomizer?.startPoint;
  const URL = `${MC_BASEURL}/customize/startingpoint/${startPoint}?shopid=${MC_SHOPID}&lang=en`;

  useEffect(() => {
    const callback = event => {
      if (
        event.data.eventName === 'mczrAddToCart' &&
        event.origin === MC_BASEURL
      ) {
        onProductCustomized(event.data.detail);
      }
    };
    window.addEventListener('message', callback);
    return () => window.removeEventListener('message', callback);
  }, [MC_BASEURL, onProductCustomized]);

  // NOTE: Using a custom color to match the BG of the iframe (once loaded), reducing flashes / whitespace
  return (
    <div className="bg-[#F7F7F7]">
      <iframe src={URL} id={id} width="100%" height="500"></iframe>
    </div>
  );
};
